import { Injectable, Inject } from '@angular/core';
import { SsoAuthService, LOGIN_SERVICE_URL, LOGIN_REALM, ID_TOKEN_NAME } from '@usana/ux/sso-auth';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { InterruptTransferService } from '@shared/lib/services/interrupt-transfer.service';

@Injectable({
  providedIn: 'root',
})
export class RefreshingLoadingService {
  private hasLoaded: boolean;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly ssoAuthService: SsoAuthService,
    private readonly interruptTransferService: InterruptTransferService,
    @Inject(ID_TOKEN_NAME) private readonly idTokenName: string,
    @Inject(LOGIN_SERVICE_URL) private readonly loginServiceUrl: string,
    @Inject(LOGIN_REALM) private readonly loginRealm: string
  ) {
    this.hasLoaded = false;
  }

  attemptRefresh(): void {
    if (!this.hasLoaded && !this.ssoAuthService.getUserUnchecked()) {
      this.hasLoaded = true;
      // do extra work
      this.httpClient
        .get(`${this.loginServiceUrl}/login/${this.loginRealm}/refresh`, {
          withCredentials: true,
          observe: 'response',
          params: {
            reuse: '1',
          },
        })
        .subscribe(
          (refreshResponse: any) => {
            // if not successful we have no user
            if (!refreshResponse.body.success) {
              this.ssoAuthService.initNoUser();
            } else if (refreshResponse.body.interrupts.length > 0) {
              // if we have interrupts transfer to the interrupts
              this.interruptTransferService.handleInterrupts(
                refreshResponse.headers.get(environment.app.ssoAccessToken),
                refreshResponse.body.interrupts
              );
            } else if (
              !refreshResponse.headers.has(this.idTokenName) ||
              !this.ssoAuthService.setUserFromIdToken(refreshResponse.headers.get(this.idTokenName))
            ) {
              // else if it was successful BUT we have no or an invalid id-token init no user
              this.ssoAuthService.initNoUser();
            }
          },
          (resp) => {
            // error so we don't have a user
            this.ssoAuthService.initNoUser();
          }
        );
    }
  }
}
